import { z } from "zod";
/**
 * UUID-shaped string validator that accepts any 8-4-4-4-12 hex pattern,
 * including version-0 ids used in the P02-T12 seed (e.g.
 * `00000000-0000-0000-0000-0000000000c2`).
 *
 * Zod v4's `.uuid()` follows RFC 9562 and rejects version-nibble values
 * outside 1-8, which excludes the seed's deliberately-zeroed UUIDs that
 * make hand-eyeballed test fixtures readable. Postgres's `uuid` column
 * type validates only the hex shape — this regex matches what the
 * database accepts.
 *
 * Use on storefront mutation bodies where the client may submit a seeded
 * id directly during dev/staging (cart variantId, checkout
 * companyLocationId). Admin endpoints can stay on strict `z.uuid()`
 * because admin-created ids always come from `crypto.randomUUID()` (v4).
 */
export const uuidLoose = z
    .string()
    .regex(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, "must be a UUID-shaped string (8-4-4-4-12 hex)");
